export default __webpack_public_path__ + "static/media/poster.104facb1.png";